import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import './loader.scss';

const Loader = ({show}) => {
  return (
    <Box sx={{ display: 'flex' }} className={show ? 'loader' : 'd-none'} >
      <CircularProgress size="3rem"/>
    </Box>
  );
}

export default Loader;